import { boxShadows, colors, mixin, themeColors } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { ItemRenderProps } from "./types"

const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 35em;
`

const itemCss = css<ItemRenderProps>`
  width: 100%;
  display: flex;
  align-items: center;
  transition:
    color,
    background-color 0.1s;
  border: 1px solid #f2f2f2;
  background-color: white;
  user-select: none;

  &:hover {
    background-color: ${colors.backgroundLightest};
  }

  ${({ isSelected }) => isSelected && itemWhiteOnGreen}

  ${({ isBeingDragged }) =>
    isBeingDragged &&
    css`
      border: none;
      box-shadow: ${boxShadows.large};
    `}
`

const itemWhiteOnGreen = css`
  &,
  &:hover {
    color: white;
    background-color: ${themeColors.primary};
  }

  > span {
    color: white;
  }
`

const nameCss = css`
  flex-grow: 1;
  padding: 1rem;
  ${mixin.noWrapEllipsis};
`

export default {
  List,
  itemCss,
  nameCss,
}
